module.exports = __webpack_public_path__ + "img/selected6-min.47bce200.png";